// Main entry point - import styles and initialize
import '../scss/style.scss';

document.addEventListener('DOMContentLoaded', () => {
  console.log('✓ App initialized - Hot reload ready!');
  
  // Initialize your components here
  // Example: initAccordions(), initCarousel(), etc.
});

// Example: Add your component initializers below
// const initAccordions = () => { ... };
